import gql from 'graphql-tag';

export const GetGiftCardTransactionHistory = gql`
  query GetGiftCardTransactionHistory($userId: ID!, $region: String) {
    giftCardTransactionHistory(userId: $userId, region: $region) {
      amount
      currencyCode
      info
      transactionTime
    }
  }
`;
